import styled from 'styled-components';

const Body = styled.div`
  flex-grow: 1;
`;

const StyledBody = styled(Body)`
  border-bottom: 1px solid ${p => p.theme.colors.gray300};
  padding: ${p => p.theme.spacing.insetLarge};
`;

export { StyledBody };
export default Body;
